var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"poster"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.headline)}}),_vm._l((_vm.paragraphs),function(paragraph){return _c('p',{key:paragraph,domProps:{"innerHTML":_vm._s(paragraph)}})}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }